<template>
    <div id="feedSearch">
        <div class="feedSearch_header">
            <search></search>
        </div>
    </div>
</template>
<script>
import search from "@/components/contents/babyFeeding/search";
export default {
    name:'feedSearch',
    data(){
        return{

        }
    },
    components:{
        search
    }
}
</script>
<style lang="less" scoped>
#feedSearch{
    width: 100%;
    height: 100vh;
    background-color: #fff;

}
</style>